import Accordion from 'react-bootstrap/Accordion';
import './Accordion.css';

import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";

function AccordionSec() {

  useEffect(() => {
    Aos.init();
}, []);

  return <section className='accordion-main' id='faq'>

  <h2 data-aos="fade-up" data-aos-duration="1000">FAQ</h2>

    <Accordion defaultActiveKey="0" data-aos="fade-up" data-aos-duration="1000">
      <Accordion.Item eventKey="0">
        <Accordion.Header>What is included in the Standard Service?</Accordion.Header>
        <Accordion.Body>
        The Standard Service, priced at $99, includes removing leaves and debris, emptying all baskets, vacuuming the pool, brushing the walls, backwashing the system if applicable, checking the water level, and water testing. Please note that adding chemicals is not included in the price.
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>What additional services are provided in the Luxury Service?</Accordion.Header>
        <Accordion.Body>
        The Luxury Service, priced at $175, includes all services from the Standard package plus additional benefits like digital water testing, checking for visible leaks and damages, ensuring proper operation of pumps, lights, and heater, checking the filtration system for proper circulation, testing salt levels, cleaning the pool deck, cleaning the automatic pool cover, and cleaning the auto cleaner bag and wall screen if applicable.
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="2">
        <Accordion.Header>Are chemicals included in the service price?</Accordion.Header>
        <Accordion.Body>
        No, the cost of chemicals is not included in the service price. They will be charged separately based on the specific needs of your pool.
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="3">
        <Accordion.Header>How often do I need to schedule pool maintenance?</Accordion.Header>
        <Accordion.Body>
        We recommend weekly pool maintenance to ensure your pool stays clean, safe, and in optimal condition.
        Regular maintenance helps prevent bigger issues and keeps your pool in perfect shape.
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="4">
        <Accordion.Header>Can I switch between Standard and Luxury services?</Accordion.Header>
        <Accordion.Body>
        Yes, you can switch between Standard and Luxury services at any time. 
        If you wish to upgrade or downgrade your service, simply contact us, and we will adjust your plan accordingly.
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="5">
        <Accordion.Header>What happens if I notice an issue with my pool between services?</Accordion.Header>
        <Accordion.Body>
        If you notice any issues with your pool between scheduled maintenance visits, please contact us immediately.
        We will arrange a service visit as soon as possible to address the problem.
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  </section>
    

}

export default AccordionSec;
